"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _context = require("../../../context");

var _utils = require("../../../utils");

var _constants = require("../constants");

var _utils2 = require("../utils");

var _Option = _interopRequireDefault(require("./Option"));

var _Select = _interopRequireDefault(require("./Select"));

var _core = require("@emotion/core");

var _excluded = ["options", "valueAccessor", "renderNativeOption", "onChange", "value", "width", "placeholder", "noOptionsText", "dataTestId"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var NativeSelect = /*#__PURE__*/_react.default.forwardRef(function (_ref, externalRef) {
  var options = _ref.options,
      valueAccessor = _ref.valueAccessor,
      renderNativeOption = _ref.renderNativeOption,
      onChange = _ref.onChange,
      value = _ref.value,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? _constants.defaultProps.width : _ref$width,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? _constants.defaultProps.placeholder : _ref$placeholder,
      _ref$noOptionsText = _ref.noOptionsText,
      noOptionsText = _ref$noOptionsText === void 0 ? _constants.defaultProps.noOptionsText : _ref$noOptionsText,
      dataTestId = _ref.dataTestId,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      selectors = _useContext.selectors;

  var isPlaceholderSelected = !value;
  var itemToString = (0, _react.useCallback)(function (item) {
    return (0, _utils2.getItemToString)(item, {
      valueAccessor: valueAccessor
    });
  }, [valueAccessor]);

  var renderOption = function renderOption(option) {
    if (renderNativeOption) {
      return renderNativeOption(option);
    }

    return itemToString(option);
  };

  var hasNoOptions = options.length === 0;

  var handleChange = function handleChange(e) {
    var newValue = options.find(function (option) {
      return itemToString(option) === e.target.value;
    });
    !!onChange && onChange(newValue);
  };

  var dataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: 'StencilSelect',
    dataTestId: dataTestId
  });
  return (0, _core.jsx)(_Select.default, (0, _extends2.default)({}, dataTestProps, {
    onChange: handleChange,
    width: width,
    placeholder: hasNoOptions ? noOptionsText : placeholder,
    ref: externalRef,
    "aria-disabled": hasNoOptions,
    style: isPlaceholderSelected ? {
      fontStyle: 'italic',
      color: selectors.color(_constants.PLACEHOLDER_TEXT_COLOR)
    } : {
      color: selectors.color(_constants.TEXT_COLOR)
    }
  }, props, {
    value: itemToString(value)
  }), options.map(function (option, index) {
    return (0, _core.jsx)(_Option.default, {
      key: index,
      value: itemToString(option)
    }, renderOption(option));
  }));
});

NativeSelect.displayName = 'NativeSelect';
var _default = NativeSelect;
exports.default = _default;